/* ==========================================================================
   Funkissd — Floating cart nudge
   Keeps the floating cart button (see funkissd-floating-cart.css) in sync
   with the real cart, no matter which theme component changed it (the cart
   notification popup, the cart page +/- controls, etc). It does this by
   watching for any fetch() call to Shopify's cart endpoints and re-reading
   /cart.js afterward, rather than depending on a specific theme's internal
   events — so it keeps working even if the cart UI changes later.

   The button itself is always visible (see the CSS — no more show/hide),
   so it also works as a quick shortcut to the cart page even before
   anything's been added. Only the quantity badge shows/hides based on
   whether the cart actually has items.
   ========================================================================== */
(function () {
  function init() {
    var el = document.getElementById('funkissd-floating-cart');
    var badge = document.getElementById('funkissd-floating-cart__badge');
    if (!el || !badge) return;

    function render(count) {
      if (!count || count < 1) {
        badge.classList.remove('is-visible');
        return;
      }
      badge.textContent = count > 99 ? '99+' : String(count);
      var wasVisible = badge.classList.contains('is-visible');
      badge.classList.add('is-visible');
      if (wasVisible) {
        el.classList.remove('is-bumping');
        // eslint-disable-next-line no-unused-expressions
        void el.offsetWidth; // restart the bump animation
        el.classList.add('is-bumping');
      }
    }

    function refresh() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          render(cart.item_count);
        })
        .catch(function () {});
    }

    refresh();

    var originalFetch = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartWrite = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
      var result = originalFetch.apply(this, arguments);
      if (isCartWrite) {
        result.then(function () {
          refresh();
        }).catch(function () {});
      }
      return result;
    };

    el.addEventListener('click', function () {
      el.classList.remove('is-bumping');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
